import { render, staticRenderFns } from "./ShiftHandOverList.vue?vue&type=template&id=4d306c42&"
import script from "./ShiftHandOverList.vue?vue&type=script&lang=js&"
export * from "./ShiftHandOverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports